import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ManagementEntityEventModel } from '@data-layer/models/management';
import { CbpMessageHelper } from '@helpers/cbp-message.helper';

@Component({
  selector: 'cbp-log-message-list',
  templateUrl: './cbp-log-message-list.component.html',
  styleUrls: ['./cbp-log-message-list.component.scss'],
})
export class CbpLogMessageListComponent implements OnChanges {
  @Input() public messageList: ManagementEntityEventModel[] = [];
  @Input() public sendToProviderDate: string;

  public sortedMessages: ManagementEntityEventModel[] = [];

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.messageList) {
      this.sortedMessages = CbpMessageHelper.sortMessages(this.messageList);
    }
  }
}
